import React, { useState, useEffect, useRef } from 'react'
import {
  CheckContainer,
  CheckWrapper,
  CheckInput,
  CheckLabel,
  Title,
  Text,
  InfoModalIcon,
} from './style'

const CheckboxItem = ({ item, isChecked, index, isInfoBtnFocused }) => {
  const { title, content, havaInfoModal, toggleModel, toggleChecked } = item
  const [checked, setChecked] = useState(false)
  const infoBtn = useRef(null)
  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])
  function handleToggle() {
    setChecked(!checked)
  }
  if (isInfoBtnFocused) {
    infoBtn.current.focus()
  }
  return (
    <CheckContainer>
      <CheckWrapper name="checkbox button">
        <CheckInput
          type="checkbox"
          name="checkbox"
          id={`${title}-${index}`}
          aria-checked={checked ? true : false}
          checked={checked}
          onClick={() => handleToggle()}
          onChange={toggleChecked(title, checked)}
        />
        <CheckLabel htmlFor={`${title}-${index}`}>
          <Title>{title}</Title>
          <Text>{content}</Text>
        </CheckLabel>
      </CheckWrapper>

      {havaInfoModal && (
        <InfoModalIcon
          onClick={toggleModel(index)}
          ref={infoBtn}
          aria-label="help button, to open help modal double click here"
        >
          More information
        </InfoModalIcon>
      )}
    </CheckContainer>
  )
}

export default CheckboxItem
